<script setup lang="ts">
type StyleProperty = 'gap'

type Props = {
  gap?: string | number
  wrap?: boolean
}

const props = defineProps<Props>()

const componentClasses = computed(() => {
  return [
    'app-skeleton-group',
    {
      'app-skeleton-group--wrap': props.wrap,
    },
  ]
})

const componentStyles = computed(() => {
  const styles: Partial<Record<StyleProperty, string | number>> = {}

  if (props.gap) styles.gap = `${props.gap}px`

  return styles
})
</script>

<template>
  <div :class="componentClasses" :style="componentStyles">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.app-skeleton-group {
  display: flex;
  width: 100%;

  &--wrap {
    flex-wrap: wrap;
  }
}
</style>
